<template>
  <!--Binds the color for the variant of the icon based on the status from nereus-->
  <!--Hover text that displays what the status is from nereus-->
  <b-badge
    class="icon-badge"
    :variant="getStatusHelper()"
    pill
  >
      <a
      :href="`${nereus_url}`"
      target="_blank"
    >
    <status-icon
      :refDes="instRD"
      :iconValue="iconValue"
    ></status-icon>
    </a>
  </b-badge>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import StatusIcons from './StatusIndicatorIcon';

export default {
  props: ['instRD'],
  data() {
    return {
      nereus_url: `${process.env.NEREUS}/help/codes`,
      iconValue: true, // sets the light colored icons
    };
  },
  components: {
    'status-icon': StatusIcons,
  },
  computed: {
    ...mapState({
      statusIndicators: (state) => state.statusIndicators,
    }),
  },
  methods: {
    // Helper method to filter through the statusIndicator information
    getStatusHelper() {
      let statusValue = _.get(this.statusIndicators, this.instRD);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
  },
};
</script>

<style>
.icon-badge {
  padding-right: 0.3em !important;
  padding-left: 0.3em !important;
}
/* Different variants for the badge based on status frorm nereus */
.badge-operational {
  background-color: #00923a !important;
}
.badge-uncabled {
  background-color: #bdbdbd !important;
}
.badge-partiallyFunctional {
  background-color: #ff6e40 !important;
}
.badge-troubleshooting {
  background-color: #fbc02d !important;
}
.badge-data_quality {
  background-color: #f57c00 !important;
}
.badge-failed {
  background-color: #c10015 !important;
}
.badge-offline {
  background-color: #9e9e9e !important;
}
.badge-not_deployed {
  background-color: #424242 !important;
}
.badge-unset {
  background-color: #9e9e9e !important;
}
.badge-default {
  background-color: #000000 !important;
}
</style>
